import keymirror from 'keymirror';

export const ACTIONS = keymirror({
    S_APP_STARTED: null,
    S_APP_REDIRECT: null,
    S_SET_PLATFORM: null,

    RESTART_GAME: null,

    OPEN_MODAL: null,
    CLOSE_MODAL: null,

    OPEN_PROFILE_MODAL: null,
    CLOSE_PROFILE_MODAL: null,

    OPEN_SIMPLE_MODAL: null,
    CLOSE_SIMPLE_MODAL: null,

    SET_QUESTION: null,
    GET_QUESTIONS: null,
    SET_QUESTION_VIEW: null,
    SET_QUESTION_LOADING: null,

    USER_UPDATE_OTHER_USER: null,
    USER_UPDATE_REMOTE_DATA: null,
    USER_UPDATE_LOCAL_DATA: null,
    USER_GET_DATA: null,
    USER_SET_DATA: null,
    USER_SET_WHATSNEXT: null,
    USER_INPUT_CHANGED: null,
    USER_SELECTED_COURSES: null,
    USER_SET_GRADUATED_COURSE: null,
    USER_SET_LOADING_DATA: null,

    // NOTIFICATION ACTIONS
    NOTIFICATION_OPEN: null,

    // COURSE REDUX ACTIONS
    COURSE_CLEAN_SELECTION: null,
    COURSE_SELECTED_COURSES: null,
    COURSE_SELECTION: null,

    // INTERACTION ACTIONS
    DISPATCH_INTERACTION: null,
    SET_INTERACTION: null,
    INTERACTION_ACTION: null,

    // CURIOSITY ACTIONS
    DISPATCH_CURIOSITY: null,
    GET_CURIOSITY: null,
    SET_CURIOSITY: null,
    SET_CURIOSITY_LOADING: null,
    DISPATCH_MISSION: null,

    // TIMER ACTIONS
    START_TIMER: null,
    STOP_TIMER: null,
    RESET_TIMER: null,
    TICK_TIMER: null,

    // FETCH ACTIONS
    GET_DASHBOARD: null,
    GET_SCHOOLS: null,
    GET_COURSES: null,
    GET_COURSES_LOADING: null,
    GET_MISSIONS_LOADING: null,
    GET_MISSIONS: null,
    SET_MISSIONS: null,

    // SESSION ACTIONS
    PROPOSE_SESSION: null,
    ACCEPT_SESSION: null,
    START_SESSION: null,
    ON_SESSION: null,
    FINISH_SESSION: null,
    SAVE_SESSION: null,
    SET_SESSION: null,
    SET_SESSION_MISSION: null,

    // LEVEL ACTIONS
    LEVEL_UP: null,
    REPEAT_LEVEL: null,

    SET_LOADING: null,
    DASHBOARD_SET_NEW_MESSAGES: null,
    SET_CURIOSITY_SHOWED: null
});



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js